<template>
  <page-content></page-content>
</template>

<script>
/*users component from view directory by router*/

// components
import PageContent from './components/PageContent.vue';

export default {
  name: 'ExtUsers',
  components: {
    PageContent
  },
}
</script>
